import {
  CancelIconButton,
  DataDisplay,
  DeleteIconButton,
  UpdateIconButton,
  GrabIconButton,
  Grid,
  ValidationErrors,
  pn,
  useElementBreakpoints,
} from "@compass/core";
import { InlineEditDataModel, Input } from "components";
import {
  CustomDataModelFieldSelectListItem,
  CustomDataModelFieldSelectListItemViewResource,
  Permission,
  PermissionAction,
} from "generated/openApi";
import { useInlineEditDataModel } from "hooks";
import produce from "immer";
import "moment-timezone";
import { isAuthorized } from "services";
import { CustomDataModelFieldSelectListOrderMethod } from "./SelectListItems";

export const SelectListItem = (props: {
  rootPermission: Permission;
  dragHandleProps: any;
  selectListItem: CustomDataModelFieldSelectListItem;
  setSelectListItem: (value: CustomDataModelFieldSelectListItem) => void;
  viewResource: CustomDataModelFieldSelectListItemViewResource;
  cancelCreate: () => void;
  validationErrors: ValidationErrors | string[];
  setEditMode: () => void;
  orderMethod: CustomDataModelFieldSelectListOrderMethod;
}) => {
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const { canCancel, canEdit, canRemove, cancel, edit, remove, editing, removing } = useInlineEditDataModel({
    dataModel: props.selectListItem,
    setDataModel: props.setSelectListItem,
    cancelCreate: props.cancelCreate,
  });

  const nameField = () => {
    const propertyName = pn<CustomDataModelFieldSelectListItem>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return !editing ? (
      <DataDisplay label={property?.displayName}>{props.selectListItem.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.selectListItem.name}
        onChange={(e) =>
          props.setSelectListItem(
            produce(props.selectListItem, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <InlineEditDataModel
      removing={removing}
      actions={
        <>
          {isAuthorized(props.rootPermission, PermissionAction.Update) && props.orderMethod === "displayOrder" && (
            <GrabIconButton {...props.dragHandleProps} size="small" />
          )}
          {isAuthorized(props.rootPermission, PermissionAction.Update) && canEdit && (
            <UpdateIconButton
              onClick={() => {
                edit();
                props.setEditMode();
              }}
              size="small"
            />
          )}
          {isAuthorized(props.rootPermission, PermissionAction.Delete) && canRemove && (
            <DeleteIconButton
              onClick={() => {
                remove();
                props.setEditMode();
              }}
              size="small"
            />
          )}
          {canCancel && <CancelIconButton onClick={cancel} size="small" />}
        </>
      }
      content={
        <Grid ref={breakpointsRef} container>
          <Grid item xs={largeFieldBreakpoints}>
            {nameField()}
          </Grid>
        </Grid>
      }
    />
  );
};
